export default "__VITE_ASSET__f557a919__"